import React, {VoidFunctionComponent} from "react";
import {triggerEcoConception} from "@/animations/responsive/productPageTracking";

export const EcoConception: VoidFunctionComponent<{ ecoScore?: string }> = ({ecoScore}) => {

    return (
        <div className='eco-conception'>
            {ecoScore !== undefined && (
                <a
                    href='#'
                    className='eco-conception-link'
                    data-toggle='collapse'
                    data-target='#eco'
                >
                    <img
                        src={`https://media.but.fr/Pictos/Pictos-FP-V3/PICTO_NOTE-${ecoScore}_HABITONS_MIEUX.svg`}
                        alt={`Habitons mieux ${ecoScore}`}
                    />
                </a>
            )}
            <p>
                Le score éco-conception « Habitons Mieux » vous guide dans vos choix de
                produits conçus dans une démarche éco-responsable pour votre intérieur :
            </p>
            <ul>
                <li>
                    4 lettres allant de A (le moins d’impact sur environnement) à D (le
                    plus d’impact sur l’environnement)
                </li>
                <li>
                    Une notation basée sur l'analyse qualitative du cycle de vie du
                    produit, des matières premières jusqu’à sa fin de vie.
                </li>
                <li>
                    Une méthodologie rigoureuse, ayant fait l’objet d’une revue critique
                    par le Pôle Eco-Conception et Management du cycle de vie, Centre
                    National de référence sur l’éco-conception, expert pour le ministère
                    de l'Environnement et de la Transition écologique, l’ADEME, l'AFNOR et
                    l’ONU-environnement.
                </li>
            </ul>
            <a
                href='/habitons-mieux#eco-conception'
                target='_blank'
                rel='noreferrer noopener'
                className='know-more'
                onClick={triggerEcoConception}
            >
                En savoir plus
            </a>
        </div>
    );
};